<template>
  <DxPopup
    :visible.sync="showPopup"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-title="true"
    title="Audit History"
    :width="550"
    :height="getHeight"
    :showCloseButton="false"
    @hidden="onHide"
    :wrapperAttr="{ class: 'css-v2 gc-popup' }"
  >
    <div class="css-v2 gc-popup-form">
      <form>
        <DxForm
          :ref="'audit-form'"
          :form-data.sync="auditModel.auditModel"
          :items="auditItems.auditItems"
        ></DxForm>
      </form>
    </div>
    <div class="footer">
      <DxButton
        :width="100"
        text="Back"
        type="default"
        styling-mode="contained"
        @click="onHide()"
      />
    </div>
  </DxPopup>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";
export default {
  props: ["showPopup", "model"],
  watch: {
    showPopup: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.$logger.trackEventOpenPopup("Audit History");
        }
      },
    },
  },
  mixins: [BaseViewMixin],
  computed: {
    auditModel() {
      return {
        auditModel: {
          FormattedDateCreated: `${
            this.model.createdBy
          } ${this.model.dateCreated.toFriendlyDBDateTimeString()}`,
          FormattedDateChanged: `${
            this.model.changedBy
          } ${this.model.dateChanged.toFriendlyDBDateTimeString()}`,
          FormattedDateCompleted: this.model.dateCompleted
            ? `${
                this.model.changedBy
              } ${this.model.dateCompleted.toFriendlyDBDateTimeString()}`
            : "",
        },
      };
    },
    auditItems() {
      return {
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: this.parseFormColumns([
              {
                dataField: "FormattedDateCreated",
                gcLabel: "Created By",
                gcType: "String",
                editorType: "dxTextBox",
                disabled: true,
                location: "left",
              },
              {
                dataField: "FormattedDateChanged",
                gcLabel: "Changed By",
                gcType: "String",
                editorType: "dxTextBox",
                location: "left",
                disabled: true,
              },
              {
                dataField: "FormattedDateCompleted",
                gcLabel: "Completed By",
                gcType: "String",
                editorType: "dxTextBox",
                location: "left",
                disabled: true,
                visible: this.model.dateCompleted ? true : false,
              },
            ]),
          },
        ],
      };
    },
    getHeight() {
      if (this.model.dateCompleted) {
        return 220;
      } else {
        return 190;
      }
    },
  },
  methods: {
    onHide() {
      this.$emit("update:showPopup", false);
    },
  },
};
</script>

<style lang="scss">
.footer {
  padding-top: 10px;
  bottom: 0;
  height: 45px;
  // width: 95%;
  text-align: right;
}
</style>
